import { render } from "./Privacy-policy.vue?vue&type=template&id=79757cc7"
import script from "./Privacy-policy.vue?vue&type=script&lang=js"
export * from "./Privacy-policy.vue?vue&type=script&lang=js"

import "./Privacy-policy.vue?vue&type=style&index=0&id=79757cc7&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\tink\\tink-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__